import React, { useState } from 'react';
import { View } from 'react-native';
import type { Meta, StoryObj } from '@storybook/react';

import { SelectField } from './SelectField';

const TIMES = ['10:00 PM', '10:30 PM', '11:00 PM', '11:30 PM', '12:00 AM'];

const meta = {
  title: 'Diary/SelectField',
  component: SelectField,
  args: {
    label: 'Bedtime',
    value: '11:00 PM',
    options: TIMES,
    onChange: () => undefined,
  },
  decorators: [
    // flex:1 root expects a ROW parent (it shares width in the diary forms)
    Story => (
      <View style={{ width: 200, flexDirection: 'row' }}>
        <Story />
      </View>
    ),
  ],
} satisfies Meta<typeof SelectField>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};

const InteractiveSelectField = (args: React.ComponentProps<typeof SelectField>) => {
  const [value, setValue] = useState(args.value);
  return (
    <View style={{ width: 200, flexDirection: 'row' }}>
      <SelectField {...args} value={value} onChange={setValue} />
    </View>
  );
};

export const Interactive: Story = {
  render: args => <InteractiveSelectField {...args} />,
};
